import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

function HybridConfig() {
  const data = useAuth();

  if (!data || !data.tenant || !data.tenant.hasHybrid) {
    return null;
  }

  return (
    <>
      <hr />
      <b>
        <i>Hybrid Configuration</i>
      </b>
      <br />
      <br />
      <div style={{ marginLeft: '10px' }}>
        <label htmlFor="hybrid-settings">Poly Cloud Services ID:</label>{' '}
        {data.tenant.stratusIdentifier}
        <br />
        <Link to="/hybrid-settings">Manage Hybrid Settings</Link>
      </div>
    </>
  );
}

export default HybridConfig;
